import React, {Component, Fragment} from "react";
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons";
import PlacebarDropdown from "./PlacebarDropdown";
import PlacebarMenuItems from "../PlacebarMenuItems";
import MobileHeader from "./PlacebarDropdown/MobileHeader";
import Navigation from "./PlacebarDropdown/Navigation";
import PropTypes from "prop-types";

const ELLIPSES = `\u2026`;

export default class PlaceMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDropDown: false
    };

    this.closeDropdown = this.closeDropdown.bind(this);
  }

  render() {
    let {disabled, itemLabel, selected} = this.props;
    let selectedLabel = selected ? selected.name : `Select one ${ELLIPSES}`;
    let className = selected ? "" : "unselected";
    return (
      <Fragment>
        <Button
          className="placebarButton placebarDropdown"
          buttonRef={ref => this.setButtonRef(ref)}
          onClick={event => this.openDropdown(event)}
          disabled={disabled}>
          <div className="placebarButtonLabel">
            <div className="placebarButtonHeader">{itemLabel}</div>
            <div className="placebarButtonSubHeader">
              <span className={className}>{selectedLabel}</span>
              <FontAwesomeIcon icon={faCaretDown} className="placebarDropdownIcon" />
            </div>
          </div>
        </Button>
        {this.state.displayDropDown && (
          <PlacebarDropdown
            className={this.placeBarClassName()}
            navigation={<Navigation onClose={this.closeDropdown} />}
            header={this.header()}
            menuItems={this.menuItems()}
            anchorEl={this.buttonRef}
            onClose={this.closeDropdown}
          />
        )}
      </Fragment>
    );
  }

  setButtonRef(ref) {
    this.buttonRef = ref;
  }

  placeBarClassName() {
    const {items, itemLabel} = this.props;

    return items.length ? itemLabel : `${itemLabel} mobileOnlyMenu`;
  }

  header() {
    const {itemLabel, parent} = this.props;
    return <MobileHeader itemLabel={itemLabel} parentItemLabel={parent && parent.name} />;
  }

  menuItems() {
    const {itemLabel, items, parent} = this.props;
    const newPath = parent ? `/facilities/${parent.getNewChildPath()}` : "/facilities";
    return <PlacebarMenuItems onClick={this.closeDropdown} itemLabel={itemLabel} items={items} newPath={newPath} />;
  }

  openDropdown(event) {
    event.preventDefault();
    this.setState({displayDropDown: true});
  }

  closeDropdown() {
    this.setState({displayDropDown: false});
  }
}

PlaceMenu.propTypes = {
  disabled: PropTypes.bool.isRequired,
  itemLabel: PropTypes.string.isRequired,
  selected: PropTypes.object,
  items: PropTypes.array.isRequired,
  parent: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/PlaceMenu.jsx